import { jsx as _jsx } from "react/jsx-runtime";
import cn from "../../../utils/cn";
import { isBetween, isSameDay } from "../../../utils/date/checkers";
const isStartOrEndDate = (date, compareDate) => {
    return date && compareDate ? isSameDay(date, compareDate) : false;
};
const isSameDateOrHover = (startDate, endDate, dateHover) => {
    const isSameDateHover = startDate && dateHover && !endDate ? isSameDay(startDate, dateHover) : false;
    return startDate && endDate ? isSameDay(startDate, endDate) : isSameDateHover;
};
const isInDateRangeOrHover = (date, startDate, endDate, dateHover) => {
    const isInDateRangeHover = date && startDate && dateHover && !endDate ? isBetween(date, startDate, dateHover) : false;
    return date && startDate && endDate ? isBetween(date, startDate, endDate) : isInDateRangeHover;
};
const DatePickerDay = ({ day, date, startDate, endDate, dateHover }) => {
    const isStartDate = isStartOrEndDate(date, startDate);
    const isEndDate = isStartOrEndDate(date, endDate);
    const isSameDate = isSameDateOrHover(startDate, endDate, dateHover);
    const isInDateRange = isInDateRangeOrHover(date, startDate, endDate, dateHover);
    return (_jsx("div", { className: cn([
            "flex h-8 w-8 items-center justify-center rounded hover:bg-gray-lightest",
            isInDateRange && "rounded-none bg-primary-light text-white hover:bg-primary-light",
            isStartDate && "rounded-r-none rounded-l bg-primary font-bold text-white hover:bg-primary",
            isEndDate && "rounded-r rounded-l-none bg-primary font-bold text-white hover:bg-primary",
            isSameDate && "rounded",
        ]), children: day }));
};
export default DatePickerDay;
